import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AES, enc } from "crypto-js";
import { useDispatch, useSelector } from "react-redux";

import Timer from "./Timer";
import {
  clearExpireTime,
  clearUserInfo,
  hideIdleModal,
  hideLoginModal,
  hideModal,
} from "../../store/auth/authSlice";

import { SessionExpired } from "./SessionExpired";
import { Modal } from "./Modal";
import { useSessionManager } from "../../Hooks/useSessionManager";

import { ReactComponent as TrevexLogo } from "../../assets/trevexLogo.svg";
import Login from "../../pages/public/Login";

const {
  REACT_APP_VERIFICATION_CODE,
  REACT_APP_PUBLIC_ACCESS_TOKEN,
  REACT_APP_ENVIRONMENT,
} = process.env;

const PrivateRoute = ({ children, token = true }) => {
  useSessionManager();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isPrompt = location.pathname.includes("prompt");

  const { showIdleModal, showLoginModal, isModalVisible, token: userToken, modalType } = useSelector(
    (state) => state.auth
  );

  // const isIdle = showIdleModal; // This modal only handles idle
  const isExpiry = modalType === "expiry";

  const otp = localStorage.getItem("appvalue");

  let originalText = "";

  try {
    const bytes = AES.decrypt(
      otp ?? "",
      REACT_APP_PUBLIC_ACCESS_TOKEN
    );

    originalText = bytes.toString(enc.Utf8);
  } catch (err) {
    console.error("OTP decrypt error:", err);
    console.error("Decrypt error:", err);
  }

  const isVerified =
    ((REACT_APP_ENVIRONMENT === "testing" ||
      REACT_APP_ENVIRONMENT === "development") &&
      originalText === REACT_APP_VERIFICATION_CODE) ||
    REACT_APP_ENVIRONMENT === "production";
  console.log(userToken, "userToken");

  const isAuthenticated = !!userToken;

  //  Redirects (Side Effects)

  // Verification redirect
  // Redirect to verification if not verified
  useEffect(() => {
    if (!isVerified) {
      navigate("/verification", { replace: true });
    }
  }, [isVerified, navigate]);

  // Login redirect
  // Redirect to login if token required
  useEffect(() => {
    if (token && !isAuthenticated) {
      navigate(isPrompt ? "/login/prompt" : "/login", {
        replace: true,
      });
    }
  }, [token, isAuthenticated, isPrompt, navigate]);

  /* --------------------------------
     Modal Handlers
  -------------------------------- */

  const handleCloseModal = () => {
    dispatch(clearUserInfo());
    dispatch(hideModal());

    navigate(isPrompt ? "/login/prompt" : "/login", {
      replace: true,
    });
  };

  const handleClose = () => {
    dispatch(hideIdleModal());
    if (isExpiry) {
      dispatch(clearExpireTime());
    }
  };
  /* --------------------------------
     Block Render if Redirecting
  -------------------------------- */

  if (!isVerified) return null;

  if (token && !isAuthenticated) return null;

  /* --------------------------------
     Render
  -------------------------------- */

  return (
    <>
      {/* Session Timer */}
      <Timer />

      {/* Protected Content */}
      {children}

      {/* Duplicate Login Modal */}
      {isModalVisible && (
        <Modal modalHandle={handleCloseModal}>
          <SessionExpired
            message="Duplicate Login Detected"
            subMessage="We noticed your account is active elsewhere. Please sign in again."
          />
        </Modal>
      )}

      {/* Login Required Modal */}
      {showLoginModal && (
        <Modal modalHandle={() => dispatch(hideLoginModal())}>
          <div className="w-[449px] px-[49px] py-8 flex flex-col justify-between">
            <div className="w-full flex justify-center">
              <TrevexLogo />
            </div>

            <h2 className="text-xl font-semibold text-center">
              Login Required
            </h2>

            <Login modalLogin preventRoute />
          </div>
        </Modal>
      )}

      {/* Idle / Expiry Modal */}
      {showIdleModal && (
        <Modal modalHandle={() => handleClose()}>
          <SessionExpired />
        </Modal>
      )}
    </>
  );
};

export default PrivateRoute;
